export default __webpack_public_path__ + "static/media/kfcLogo.492728c6.svg";